import { render, staticRenderFns } from "./BeneficialBacteria.vue?vue&type=template&id=6bae6c0c&scoped=true&"
import script from "./BeneficialBacteria.vue?vue&type=script&lang=js&"
export * from "./BeneficialBacteria.vue?vue&type=script&lang=js&"
import style0 from "./BeneficialBacteria.vue?vue&type=style&index=0&id=6bae6c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae6c0c",
  null
  
)

export default component.exports